module.exports = __webpack_public_path__ + "img/finished.9374cf21.png";